<template>
  <div class="relative">
    <input-button
      class="relative flex w-full items-center justify-between rounded-none border border-grey-30 bg-white px-4 py-2 text-left text-sm font-normal text-black"
      :class="classes"
      styleType="none"
      @onClick="onClick"
    >
      {{ buttonText }}
      <chevron-down class="h-5 w-5" />
    </input-button>
    <input-error-popup
      v-if="this.showErrorPopup"
      :error-message="errorMessage"
    />
  </div>
</template>

<script>
import InputButton from 'Components/InputButton.vue';
import ChevronDown from 'Components/Icons/IconChevronDown';
import InputErrorPopup from 'Components/InputErrorPopup';
import input from 'Mixins/input';
import showErrorPopup from 'Mixins/showErrorPopup';
import { mapGetters } from 'vuex';

export default {
  name: 'IndustrySelect',
  mixins: [input, showErrorPopup],
  components: {
    InputErrorPopup,
    InputButton,
    ChevronDown,
  },

  computed: {
    ...mapGetters('info', ['getIndustry']),
    buttonText() {
      if (!this.value) {
        return this.placeholder;
      }
      const industryObject = this.getIndustry(this.value);
      if (!industryObject) {
        return this.placeholder;
      }
      return industryObject.industry_name_1;
    },
    classes() {
      return {
        'bg-red-200': this.error,
      };
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick');
    },
  },
};
</script>
